var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 20.3373L18.4444 23.4485L24.6667 17.2262M33.4056 10.9796C33.0873 10.9958 32.7668 11.0039 32.4444 11.0039C27.6635 11.0039 23.3024 9.20659 19.9999 6.25073C16.6974 9.20648 12.3364 11.0038 7.55556 11.0038C7.2332 11.0038 6.91276 10.9956 6.59442 10.9794C6.20643 12.4784 6 14.0504 6 15.6707C6 24.3686 11.9489 31.6771 20 33.7493C28.0511 31.6771 34 24.3686 34 15.6707C34 14.0505 33.7936 12.4785 33.4056 10.9796Z",
    stroke: "#171717",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shield-check.a01ae3f9d67557f697ae1fa0c8bfaacf.svg";
export { ForwardRef as ReactComponent };